import { useRelaunchStore } from '../../../stores/admin/relauch';
import useModal from '../../../hooks/useModal';
import pen from "../../../assets/icons/edit.svg";
import trash from "../../../assets/icons/trash.svg";
import UpdateRelaunch from '../Modales/UpdateRelaunch';
import DeleteRelaunch from '../Modales/DeleteRelaunch';

const RelaunchAdminTable = () => {
  // Hook
  const { modalContent, isModalOpen, openModal, closeModal } = useModal();
  // Store
  const { relaunchs } = useRelaunchStore();

  return (
    <div className="w-full h-full">
      {isModalOpen ? modalContent : null}
    
    {/* En-têtes de colonnes avec design moderne */}
    <div className="bg-gray-50 border-b border-gray-200 px-6 py-4 sticky top-0">
        <div className="grid grid-cols-5 gap-4 text-sm font-semibold text-gray-700">
          <div className="col-span-1 flex items-center">
            <span className="flex items-center gap-2">
              <svg className="w-4 h-4 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z" />
              </svg>
              Type
            </span>
          </div>
          <div className="col-span-1 flex items-center">
            <span className="flex items-center gap-2">
              <svg className="w-4 h-4 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              Nombre de jours
            </span>
          </div>
          <div className="col-span-2 flex items-center">
            <span className="flex items-center gap-2">
              <svg className="w-4 h-4 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
              </svg>
              Texte
            </span>
          </div>
          <div className="col-span-1 flex items-center justify-center">
            <span className="text-center">Actions</span>
          </div>
        </div>
      </div>

      {/* Corps de la table avec design moderne */}
      <div className="w-full overflow-y-auto max-h-[calc(90vh-20rem)]">
        {relaunchs?.length === 0 || relaunchs === undefined ? (
          <div className="text-center py-12">
            <div className="w-16 h-16 mx-auto mb-4 bg-gray-100 rounded-full flex items-center justify-center">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#484848" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-repeat"><polyline points="17 1 21 5 17 9"></polyline><path d="M3 11V9a4 4 0 0 1 4-4h14"></path><polyline points="7 23 3 19 7 15"></polyline><path d="M21 13v2a4 4 0 0 1-4 4H3"></path></svg>
            </div>
            <h3 className="text-lg font-medium text-gray-900 mb-2">Aucun relance trouvée</h3>
            <p className="text-gray-500">Vous n'avez pas encore créé de relance.</p>
          </div>
        ) : (
          relaunchs.map((relaunch) => (
            <div key={relaunch.id} className="grid grid-cols-5 gap-4 px-6 py-4 border-b border-gray-200">
              <div className="col-span-1">{relaunch.title}</div>
              <div className="col-span-1">{relaunch.amountOfDays}</div>
              <div className="col-span-2 text-sm">{relaunch.text}</div>
              <div className="col-span-1 flex items-center justify-center gap-2">
                {/* Bouton Modifier */}
                <button
                    type="button"
                    className="p-2 bg-blue-100 hover:bg-blue-200 rounded-lg transition-colors duration-200 cursor-pointer group"
                    onClick={() => {
                      openModal(<UpdateRelaunch id={relaunch.id} closeModal={closeModal} />);
                    }}
                    title="Modifier"
                  >
                    <img 
                      className="w-4 h-4 group-hover:scale-110 transition-transform duration-200" 
                      src={pen} 
                      alt="stylo" 
                    />
                  </button>
                  
                  {/* Bouton Supprimer */}
                  <button
                    type="button"
                    className="p-2 bg-red-100 hover:bg-red-200 rounded-lg transition-colors duration-200 cursor-pointer group"
                    onClick={() => {
                      openModal(<DeleteRelaunch idRelaunch={relaunch.id} closeModal={closeModal} />);
                    }}
                    title="Supprimer"
                  >
                    <img 
                      className="w-4 h-4 group-hover:scale-110 transition-transform duration-200" 
                      src={trash} 
                      alt="poubelle" 
                    />
                  </button>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default RelaunchAdminTable;